import { render } from "./StackField.vue?vue&type=template&id=00157970"
import script from "./StackField.vue?vue&type=script&lang=js"
export * from "./StackField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"StackField.vue"]])

export default __exports__